/* CBG: search and expand Set options without changing Shopify filter URLs. */
(function () {
  'use strict';
  function normalize(text) {
    return String(text).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  }

  function getSetFilterView(items, query, expanded, initialCount) {
    var search = normalize(query);
    var matches = items.map(function (item, index) { return { item: item, index: index }; })
      .filter(function (entry) { return normalize(entry.item.label).includes(search); });
    var shown = matches.filter(function (entry, index) {
      return search || expanded || index < initialCount || entry.item.active;
    }).map(function (entry) { return entry.index; });
    return { shown: shown, count: matches.length,
      toggle: !search && matches.length > shown.length || !search && expanded && matches.length > initialCount,
      scroll: Boolean(search || expanded), empty: matches.length === 0 };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { getSetFilterView: getSetFilterView };
  if (typeof document === 'undefined' || window.CBGSetFilterLoaded) return;
  window.CBGSetFilterLoaded = true;
  var initialized = new WeakSet();
  var nextId = 0;

  function init(group) {
    if (initialized.has(group)) return;
    var input = group.querySelector('[data-cbg-set-search]');
    var list = group.querySelector('[data-cbg-set-list]');
    var toggle = group.querySelector('[data-cbg-set-toggle]');
    var empty = group.querySelector('[data-cbg-set-empty]');
    var status = group.querySelector('[data-cbg-set-status]');
    if (!input || !list || !toggle || !empty || !status) return;
    initialized.add(group);
    var rows = Array.from(list.querySelectorAll('[data-cbg-set-label]'));
    var items = rows.map(function (row) {
      return { label: row.dataset.cbgSetLabel, active: row.dataset.filterOpen === 'true' };
    });
    var expanded = false;
    list.id = 'cbg-set-options-' + (++nextId);
    toggle.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-controls', list.id);
    group.querySelector('[data-cbg-set-controls]').hidden = false;

    function render(resetScroll) {
      var view = getSetFilterView(items, input.value, expanded, 4);
      rows.forEach(function (row, index) { row.hidden = !view.shown.includes(index); });
      list.classList.toggle('cbg-set-filter__list--scroll', view.scroll);
      if (resetScroll) list.scrollTop = 0;
      toggle.hidden = !view.toggle;
      toggle.textContent = expanded ? 'Show Less -' : 'Show More +';
      toggle.setAttribute('aria-expanded', String(expanded));
      empty.hidden = !view.empty;
      var text = input.value.trim() ? view.count + (view.count === 1 ? ' matching set.' : ' matching sets.') : '';
      if (status.textContent !== text) status.textContent = text;
    }
    input.addEventListener('input', function () { render(true); });
    input.addEventListener('keydown', function (event) {
      // Searching the list must never submit a surrounding filter form.
      if (event.key === 'Enter') event.preventDefault();
      if (event.key === 'Escape' && input.value) { event.preventDefault(); input.value = ''; render(true); }
    });
    toggle.addEventListener('click', function () { expanded = !expanded; render(true); });
    render(false);
  }

  function scan(root) {
    if (root.nodeType === 1 && root.matches('[data-cbg-set-filter]')) init(root);
    root.querySelectorAll('[data-cbg-set-filter]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  // The mobile filter modal can move or clone the sidebar. WeakSet tracking
  // initializes new clones while preserving state when an existing node moves.
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
